import type { JSX } from "react";
import { FunctionCallItemView } from "./FunctionCallItem";
import { FunctionOutputItemView } from "./FunctionOutputItem";
import { MessageItemView } from "./MessageItem";
import { ReasoningItemView } from "./ReasoningItem";
import type { ItemViewProps } from "./types";

export function ItemView(props: ItemViewProps): JSX.Element | null {
    const { item } = props;

    switch (item.type) {
        case "MESSAGE":
            return <MessageItemView {...props} />;
        case "FUNCTION_CALL":
            return <FunctionCallItemView {...props} />;
        case "FUNCTION_CALL_OUTPUT":
            return <FunctionOutputItemView {...props} />;
        case "REASONING":
            return <ReasoningItemView {...props} />;
        default:
            return null;
    }
}
